import { useAuthStore } from "@/stores/auth.store.js";
import { Button } from "@/components/ui/Button.js";
import { Icon } from "@/components/ui/icons.js";

interface TopbarProps {
  title: string;
  onToggleSidebar: () => void;
  onLogout: () => void;
}

export function Topbar({ title, onToggleSidebar, onLogout }: TopbarProps) {
  const { user } = useAuthStore();

  return (
    <header className="topbar">
      <div className="topbar__left">
        <button
          className="topbar__toggle"
          onClick={onToggleSidebar}
          aria-label="Navigation umschalten"
          title="Navigation umschalten"
        >
          <Icon name="menu" size={20} />
        </button>
        <span className="topbar__title">{title}</span>
      </div>

      <div className="topbar__right">
        {user && (
          <span className="topbar__tenant">
            {user.role.toUpperCase()} · Tenant {user.tenantId.slice(0, 8)}…
          </span>
        )}
        <Button variant="secondary" size="sm" icon="logout" onClick={onLogout}>
          Abmelden
        </Button>
      </div>
    </header>
  );
}
